import axios from 'axios';
import store from '@/store/index';
import router from '@/router/index';

// ----------------------------- o

const versionApi = 'v1';

// ----------------------------- o

const api = axios.create({
    // baseURL: 'https://api.portalgastro.pl/'+versionApi, // prod
    // baseURL: 'https://api-portalgastro2.dev-is.pl/'+versionApi, // test
    baseURL: 'https://api-portal-gastro-cz.dev-is.pl/'+versionApi, // test
    headers: {
        'Authorization' : localStorage.getItem('access_token') ? localStorage.getItem('access_token') : '',
    }
})

// ----------------------------- o

api.interceptors.response.use(
    response => {
        return response;
    },
    error => {
    let message = null;
    // set message if exists
    if(error.response && error.response.data && error.response.data.message){
        message = error.response.data.message;
    }
    // bad request
    if (error.response.status === 400) {
        console.log("%c 400 intercept! ", 'background: #ff0000; color: #fff');
        store.dispatch('GLOBAL_TOAST', message ? message : 'Błąd - spróbuj później.');
    }
    // unauthenticated
    if (error.response.status === 401) {
        console.log("%c 401 intercept! ", 'background: #ff0000; color: #fff');
        store.dispatch('GLOBAL_REMOVE_USER');
        store.dispatch('GLOBAL_TOAST', message ? message : 'Token wygasł - zaloguj się ponownie.');
        router.push({name: 'Login'}).catch(err => {})
    }
    // unauthorized
    if (error.response.status === 403) {
        console.log("%c 403 intercept! ", 'background: #ff0000; color: #fff');
        store.dispatch('GLOBAL_TOAST', message ? message : 'Brak dostępu.');
    }
    // unknown route
    if (error.response.status === 404) {
        console.log("%c 404 intercept! ", 'background: #ff0000; color: #fff');
        store.dispatch('GLOBAL_TOAST', message ? message : 'Nie odnaleziono szukanego zasobu.');
    }
    // validation errors
    if (error.response.status === 422) {
        console.log("%c 422 intercept! ", 'background: #ff0000; color: #fff');
        store.dispatch('GLOBAL_TOAST', message ? message : 'Nieprawidłowe dane.');
    }
    // server error
    if (error.response.status === 500) {
        console.log("%c 500 intercept! ", 'background: #ff0000; color: #fff');
        store.dispatch('GLOBAL_TOAST', message ? message : 'Błąd serwera - spróbuj później.')
    }
    // server down
    if (error.response.status === 503) {
        console.log("%c 503 intercept! ", 'background: #ff0000; color: #fff');
        store.dispatch('GLOBAL_TOAST', message ? message : 'Przerwa techniczna.')
    }
    return Promise.reject(error);
});

// ----------------------------- o

export default api